import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { views } from "../../../application/auth";
import PasswordlessEmailConsumeLink from "./passwordless/emailConsumeLink";
import PasswordlessEmailForm from "./passwordless/emailForm";
import PasswordlessOTPForm from "./passwordless/otpForm";

const Auth: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const linkCode = queryParams.get("linkCode");

  const useViewState = useState<views>("email");
  const useEmailState = useState<string | undefined>();
  const useErrorState = useState<string>("");

  const [view, setView] = useViewState;

  const sharedProps = {
    useErrorState,
    useEmailState,
    useViewState,
  };

  useEffect(() => {
    if (linkCode) {
      setView("consumeEmailLink");
    }
  }, [linkCode]);

  switch (view) {
    case "email":
      return <PasswordlessEmailForm {...sharedProps} />;
    case "otp":
      return <PasswordlessOTPForm {...sharedProps} />;
    case "consumeEmailLink":
      return <PasswordlessEmailConsumeLink {...sharedProps} />;
    default:
      return <PasswordlessEmailForm {...sharedProps} />;
  }
};

export default Auth;
